<template>
    <div>
        <b-modal
            v-model="showModal"
            hide-footer
            modal-class="hide-footer"
            size="sm"
            no-close-on-backdrop
            no-close-on-esc
            :title="titlePopup"
        >
            <b-form>
                <div class="row custom-model-form">
                    <div class="col-md-12">
                        <b-form-group id="input-group-3" label="Score">
                            <b-form-input
                                v-model="editedItem.score"
                                v-validate="{
                                    required: true,
                                    regex: /^([0-9]*)$/,
                                    min: 1,
                                    max: 3,
                                }"
                                type="text"
                                name="score"
                                placeholder="Enter score"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                </div>
                <div class="col-md-12 action-buttons">
                    <b-button @click="submitForm">Update</b-button>
                </div>
            </b-form>
        </b-modal>
    </div>
</template>
<script>
export default {
    props: {
        showModal: {
            type: Boolean,
            default: false,
        },
        editedItem: Object,
        title: {
            type: String,
            default: null,
        },
    },
    data() {
        return {}
    },
    computed: {
        titlePopup() {
            if (this.editedItem) {
                return this.editedItem.proximity == 'Exact'
                    ? 'Exact Match Score'
                    : this.editedItem.proximity == 'Close'
                    ? 'Close Match Score'
                    : this.editedItem.proximity == 'Mismatch'
                    ? 'Mismatch Score'
                    : 'Date of Birth Match Score'
            } else {
                return 'Date of Birth Match Score'
            }
        }, // End of titlePopup() method
    },
    watch: {},
    methods: {
        submitForm() {
            this.$emit('submit')
        },
    },
}
</script>
<style scoped>
/* Add styling for your modal if needed */
</style>
